import React from 'react'
import { PdaTitleProps } from '../../types/common'
import { Divider } from 'primereact/divider'
import { useNavigate } from 'react-router-dom'
import LanguagePopover from '../../component/language-swich/language-popover'

const PdaTitle = (props: PdaTitleProps) => {
    const navigate = useNavigate()
    const onClickHistoryback = () => {
        navigate(-1)
    }

    const onClickGoToHome = () => {
        navigate('/')
    }

    return (
        <div className="grid pda-title flex pl-1">
            <div className="mt-3 col-12 flex font-bold grid p-0">
                <div className="col-3 flex">
                    {props.historyBack ? <i className="pi pi-chevron-left text-xl pl-4" onClick={onClickHistoryback} /> : ''}
                </div>
                <div className="col-6 flex justify-content-center text-lg">{props.title}</div>
                <div className="col-3 flex justify-content-end">
                    {props.home ? <LanguagePopover /> : props.goToHome ? <i className="pi pi-home text-xl pr-3" onClick={onClickGoToHome} /> : ''}
                </div>
            </div>
            <Divider className="mt-1 mb-0" />
        </div>
    )
}

export default PdaTitle
